import React from 'react';
import { Form, Select } from 'antd';
import type { SurveyTagOption } from '../../types/tag.types';

interface SurveyTagFieldProps {
  availableTags: SurveyTagOption[];
  selectedTagIds: string[];
  linkedTags?: Array<{
    id: string;
    name: string;
    status: 'ACTIVE' | 'INACTIVE';
  }>;
  onChange: (tagIds: string[]) => void;
}

const MAX_TAGS = 2;

const SurveyTagField: React.FC<SurveyTagFieldProps> = ({
  availableTags,
  selectedTagIds,
  linkedTags = [],
  onChange,
}) => {
  const selectedInactiveTags = linkedTags.filter(
    (tag) => tag.status === 'INACTIVE' && selectedTagIds.includes(tag.id),
  );

  const tagOptions = [
    ...availableTags.map((tag) => ({
      value: tag.id,
      label: tag.name,
      disabled: false,
    })),
    ...selectedInactiveTags
      .filter((inactiveTag) => !availableTags.some((activeTag) => activeTag.id === inactiveTag.id))
      .map((inactiveTag) => ({
        value: inactiveTag.id,
        label: `${inactiveTag.name} (inativa)`,
        disabled: false,
      })),
  ];

  const hasInactiveSelection = selectedInactiveTags.length > 0;

  return (
    <Form.Item
      label="Etiquetas da Pesquisa"
      validateStatus={hasInactiveSelection ? 'warning' : undefined}
      help={
        hasInactiveSelection
          ? 'Há etiqueta(s) inativa(s) associada(s). Remova ou substitua por etiquetas ativas para salvar.'
          : 'Selecione até 2 etiquetas ativas para a pesquisa.'
      }
    >
      <Select
        mode="multiple"
        allowClear
        maxCount={MAX_TAGS}
        value={selectedTagIds}
        onChange={(values) => onChange(values.slice(0, MAX_TAGS))}
        options={tagOptions}
        placeholder="Selecione até 2 etiquetas"
      />
    </Form.Item>
  );
};

export default SurveyTagField;
